/* eslint-disable @reatom/unit-naming-rule */
import { useAction } from '@reatom/npm-react'
import styled from 'styled-components'
import { useMemo } from 'use-memo-one'

import { openTransactionDetailsDialogAction } from '@root/entities/transaction/atoms'
import { reatomUserTransactions } from '@root/features/user/transaction-history/atoms/reatom-user-transactions'
import { TransactionsFilters } from '@root/features/user/transaction-history/ui/filters/transactions-filters'
import { TransactionHistoryList } from '@root/features/user/transaction-history/ui/transaction-history-list'
import { TransactionHistoryListEmpty } from '@root/features/user/transaction-history/ui/transaction-history-list-empty'

import type { WalletModel } from '@root/entities/wallet/atoms'

type WalletTransactionsProps = {
  wallet: WalletModel
}

export const WalletTransactions: React.FC<WalletTransactionsProps> = ({
  wallet,
}) => {
  const model = useMemo(
    () =>
      reatomUserTransactions({
        delugeId: undefined,
        network: wallet.network,
        pairAddress: undefined,
        initialWalletIdsFilter: [wallet.id],
      }),
    [wallet.id, wallet.network],
  )

  const openTransactionDetailsDialog = useAction(
    openTransactionDetailsDialogAction,
  )

  return (
    <Root>
      <Filters model={model} />
      <TransactionHistoryList
        model={model}
        renderEmptyMessage={() => (
          <TransactionHistoryListEmpty
            infoVariant="bold"
            withRetry
            transactionsOwner="current"
          />
        )}
        onOpenTransactionDetails={openTransactionDetailsDialog}
        withWallet={false}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`

const Filters = styled(TransactionsFilters)`
  border-top: none;
`
